import { CdkMenuModule } from '@angular/cdk/menu';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PalantirButtonComponent } from '../button/button.component';
import { PalantirContentComponent } from '../content/content.component';
import { PalantirTextComponent } from '../text/text.component';
import { scaleInOut } from './bulk-actions.animations';

@Component({
  selector: 'palantir-bulk-actions',
  templateUrl: './bulk-actions.component.html',
  styleUrls: ['./bulk-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PalantirTextComponent,
    PalantirButtonComponent,
    PalantirContentComponent,
    CdkMenuModule,
  ],
  animations: [scaleInOut],
})
export class PalantirBulkActionsComponent {
  public itemsLength = input.required<number>();

  public selectedLabel = input.required<string>();

  public hideMenuButton = input(false);
}
